/**
 * Busca na conversa — onde o termo aparece dentro do texto de uma bolha, pra
 * destacar. O servidor acha as mensagens sem diferença de acento nem de
 * maiúscula (`unaccent` + `ILIKE`); aqui vale a mesma regra, senão a bolha
 * achada por "orcamento" não destacaria o "Orçamento" que ela tem.
 */

/** Forma de comparação de um pedaço de texto: sem acento, minúsculo. */
function formaDeComparacao(trecho: string): string {
  return trecho.normalize('NFD').replace(/\p{M}/gu, '').toLowerCase();
}

/**
 * Trechos `[início, fim)` do texto ORIGINAL onde o termo aparece, sem
 * sobreposição, na ordem. Termo vazio (ou só espaços) não acha nada.
 *
 * Tirar o acento muda o tamanho do texto ("é" decomposto vira 2 unidades;
 * a marca some) — por isso cada unidade do texto comparado guarda de que
 * posição do original veio, e o trecho achado é devolvido em posições do
 * original, prontas pra fatiar a string que a bolha mostra.
 */
export function trechosDoTermo(texto: string, termo: string): Array<[number, number]> {
  const alvo = formaDeComparacao(termo.trim());
  if (!alvo || !texto) return [];

  let comparado = '';
  const inicioNoOriginal: number[] = [];
  const fimNoOriginal: number[] = [];
  let pos = 0;
  for (const ponto of texto) {
    const fim = pos + ponto.length;
    const forma = formaDeComparacao(ponto);
    if (forma.length === 0) {
      // Marca de acento solta (texto já decomposto): some na comparação, mas
      // pertence à letra anterior — estica o fim dela pra o destaque incluir.
      if (fimNoOriginal.length > 0) fimNoOriginal[fimNoOriginal.length - 1] = fim;
    } else {
      for (let i = 0; i < forma.length; i++) {
        inicioNoOriginal.push(pos);
        fimNoOriginal.push(fim);
      }
      comparado += forma;
    }
    pos = fim;
  }

  const trechos: Array<[number, number]> = [];
  let de = 0;
  for (;;) {
    const achou = comparado.indexOf(alvo, de);
    if (achou === -1) break;
    const ultimo = achou + alvo.length - 1;
    trechos.push([inicioNoOriginal[achou] as number, fimNoOriginal[ultimo] as number]);
    de = achou + alvo.length;
  }
  return trechos;
}
